var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.558 21.3159V11.8166M16.558 11.8166C14.6079 11.8166 13.027 10.2833 13.027 8.39188C13.027 6.50047 14.6079 4.96717 16.558 4.96717M16.558 11.8166C18.5081 11.8166 20.089 10.2833 20.089 8.39188C20.089 6.50047 18.5081 4.96717 16.558 4.96717M16.558 2.68403V4.96717M7.44113 2.68403L7.44113 12.1834M7.44113 12.1834C5.49103 12.1834 3.91016 13.7167 3.91016 15.6081C3.91016 17.4995 5.49103 19.0328 7.44113 19.0328M7.44113 12.1834C9.39124 12.1834 10.9721 13.7167 10.9721 15.6081C10.9721 17.4995 9.39124 19.0328 7.44113 19.0328M7.44113 21.3159V19.0328",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.8a49c1efb0c09e66b54113a3231e843d.svg";
export { ForwardRef as ReactComponent };